// Text search of the picker dialogs (products, offers). The legacy product modal matched a case-insensitive regex on the
// name, the EAN and the description (productsVM.searchByText) ; accents are ignored here as well, so "creme" finds "Crème".

const normalize = (value) =>
	String(value ?? '')
		.normalize('NFD')
		.replace(/[̀-ͯ]/g, '')
		.toLowerCase()
		.trim();

/** Items whose name, EAN or description contains every word of the search text. */
export function filterPickerItems(items, text) {
	const list = Array.isArray(items) ? items : [];
	const words = normalize(text).split(/\s+/).filter(Boolean);
	if (!words.length) return list;
	return list.filter((item) => {
		const haystack = normalize(`${item?.name ?? ''} ${item?.ean ?? ''} ${item?.description ?? ''}`);
		return words.every((word) => haystack.includes(word));
	});
}
